import { Field, OperationButton } from 'components/core-v2'
import { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useNavigate, useParams } from 'react-router-dom'

import {
  useGetByTenantAccountAndAccountSourceAccountIdentifierQuery,
  usePostByTenantAccountCloseAndAccountIdentifierMutation
} from '@/api'
import { PATH, TENANT } from '@/const'
import { useUser } from '@/utilities/hooks/useUser'

import { TradeTemplate } from '../../templates/trade-template'
import classes from './index.module.scss'

export const ReportingTradeClosePage = () => {
  const form = useForm()
  const { data: user } = useUser()
  const { source, tradeId } = useParams()
  const { data } = useGetByTenantAccountAndAccountSourceAccountIdentifierQuery({
    tenant: TENANT,
    accountIdentifier: tradeId,
    accountSource: source
  })

  const navigate = useNavigate()

  const fieldValue = form.watch('username')

  const [mutate, { isLoading, isSuccess }] =
    usePostByTenantAccountCloseAndAccountIdentifierMutation()

  useEffect(() => {
    if (isSuccess) {
      navigate(PATH.reportsTrades)
      if (data) {
        toast.success(`Trade ${data.account.accountName} successfully closed`)
      }
    }
  }, [data, isSuccess, navigate])

  return (
    <TradeTemplate tabValue="close">
      <FormProvider {...form}>
        <section className={classes.root}>
          <h2>Close the trade</h2>
          <p>By proceeding with this instruction to close the trade the following will occur:</p>
          <ul>
            <li>All holdings inside the trade will be sold.</li>
            <li>
              All proceeds of the sale of the holdings (after deductions to cover any outstanding
              fees and load payments) will be repaid to the holder of the note.
            </li>
            <li>The trade will no longer form part of the note.</li>
          </ul>
          <p>Please carefully consider if you wish to proceed.</p>
          <Field
            data-private
            id="username"
            label="Please enter your username"
            placeholder={user.userName}
            type="string"
          />
          <OperationButton
            isDisabled={!(fieldValue === user.userName)}
            isLoading={isLoading}
            operationType="progress"
            onClick={() => {
              mutate({
                tenant: TENANT,
                accountIdentifier: tradeId
              })
            }}
          >
            Close trade
          </OperationButton>
        </section>
      </FormProvider>
    </TradeTemplate>
  )
}
